exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "option[data-v-07800efe]:disabled {\n  color: #aaaaaa !important;\n}", ""]);

// exports
